import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import "./BillingPaymentForm.scss";
import ArrowBack from '../../components/ArrowBack/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getSuburbsByCp } from "../../utils/cities";
import ButtonBase from "../Buttons/ButtonBase";
import { createBillingLaywers ,createFingerprint, createStatusMembership} from "../../store/actions/billingAction";
import { validationBilling,validationCard } from '../../utils/validations';
import PaymentForm from '../BillingCardAnimation/BillingCard'
import MaskedInput from 'react-text-mask';
import FormHelperText from '@material-ui/core/FormHelperText';
import Cards from 'react-credit-cards';
import 'react-credit-cards/lib/styles.scss';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import axios from 'axios';
import {facturaProduc} from '../../utils/facturapi/membresias'
import Checkbox from '@material-ui/core/Checkbox';
import ContractModal from '../Modal/ContractModal';
import { openModalPayments } from '../../store/actions/ModalsActions';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import AccountCircle from '@material-ui/icons/AccountCircle';
import {getCodeErrorMessage} from '../../utils/stripe'
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
  } from '@material-ui/core';

import {
    TextField
} from '@material-ui/core';
import { showLoading, hideLoading } from "../../store/actions/LoadingActions";

const useStyles = makeStyles(theme => ({

    inputLabelRoot: {
        transform: 'translate(14px, 16px) scale(1)',
    },
    formHelperTextRoot: {
        margin: '8px 14px',
        marginBottom: 0,
    },
    inputError: {
        border: '1px solid #d74242',
        '&:hover': {
            border: '1px solid #d74242',
        },
    },
    tooltipParagraph: {
        margin: 0,
        fontSize: 14,
        '& b': {
          fontSize: 14,
          fontWeight: 'bold',
        },
    },
    customTooltip: {
        backgroundColor: '#094565',
        margin: '10px 8px 0',
        padding: 8,
        maxWidth: 232,
        lineHeight: 1.2,
      },
    rootFormControl: {
        width: 'auto',
        height: 40,
        display: 'flex',
        alignItems: 'center',
      },
    TextField: {
        maxWidth: '448px',
    },
    TextFieldS: {
        maxWidth: '176px',
    },
    TextField_small: {
        maxWidth: '46%',
    },
    colorActiveCheck: {
      color: '#484848',
      fontSize: 12,
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      margin: 0,
      paddingLeft: 0
      },
    colorActiveLabel: {
      '&:hover': {
        color: '#094565'
      },
      color: '#c1c1c1',
      fontSize: 12,
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      margin: 0,
      paddingLeft: 0
    },
    labelTermino: {
      fontWeight: '400'
    },
    FormControlLabelRoot: {
      margin: 0
    },
    checkPadding: {
      padding: '0',
      marginRight: 4,
    },
    IconButtonRoot: {
      color: '#c1c1c1',
      padding: 5
    },
    linkTerms: {
      textDecoration: 'none',
      color: 'inherit'
    },
    button: {
      width: '100%'
    }
}));

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        placeholder="MM/YY"
        mask={[ /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/]}
      />
    );
  }
  
  TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };


const BillingPaymentForm = (props) => {
    const { billing, handleCheckout, modalPayments, showLoading, hideLoading ,createFingerprint,createStatusMembership, laywerUid,
        name,firstLastName,secondLastName ,typeMembership,email} = props
    const classes = useStyles();
    const [devide, setDevice] = useState()
    const [flagLocation, setFlagLocation] = useState(false)
    const [location, setLocation] = useState({})
    const [neighborhoodData, setNeighborhoodData] = useState()
    const [laywerId, setLaywerId] = useState()
    const history = useHistory();
    const [focus, setFocusData] = useState();
    const [membershipFilter, setMembershipFilter] = useState();
    const [openContract, setOpenContract] = React.useState(false);



    useEffect(() => {
        modalPayments && modalPayments.membershipRole && facturaProduc(modalPayments.membershipRole, "Premium", modalPayments.typePayment).then(res=>setMembershipFilter(res))
       

    }, []);
    const handleBackData = () => {
        history.push('/dashboard/membresia')
    };


    const formBillingValues = {
        name: "",
        number: "",
        expiry: "",
        cvc: "",
        typeCard:'credito',
        termsAndConditions: false,
        contract: false
    };
    


    const handleClickOpen = () => {
        setOpenContract(true);
  };

  const handleClose = (value) => {
    setOpenContract(false);
  };

    const handleSubmitBillingPaymentForm = async (values,{setFieldError,setFieldValue}) => {
        showLoading()
        console.log(typeMembership)
        let errorCard;
        const [month, year,] = values.expiry.split('/');

        let info ={
        
                "number":values.number,
                "name":values.name,
                "month": month,
                "year": `20${year}` ,
                "cvc": values.cvc,
                "currency":"mxn",
                "country":"México"
            
        }


        await axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createToken`, info, {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
            }
          }
          ).then(function (response) {
            if(response.data.id){
                 axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createCardByClient`, {clientId: billing.idStripe, 
                 tokenCard: response.data.id}, {
                    headers: {
                    'Content-Type': 'application/json',
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
                    }
                  }
                ).then(function (response) {
                  

                    //UID Client
                   createFingerprint(laywerUid, response.data.fingerprint)


                axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/createSubscription`, 
                    {clientId: billing.idStripe, 
                    idCard: response.data.id,
                    priceId: membershipFilter.stri}, {
                       headers: {
                       'Content-Type': 'application/json',
                       "Access-Control-Allow-Origin": "*",
                       'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
                       }
                     }
                   ).then(function (response) {
                       //UID Client
                        console.log('response sus', response)

                        if(response.data.error){
                            setFieldError('number', "Error en el proceso")
                            hideLoading()
                        }else{

                            if(response.data.status == "active"){
                                let typeCard = values.typeCard == "debito" ? '28':'04';
                                console.log(typeCard)
                                createStatusMembership(laywerUid)
        
                               axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/invoices/create`, {
                                "customer": billing.idFacturapi,
                                "items": [{
                                  "quantity": 1,
                                  "product": membershipFilter.fac
                                }],
                                "payment_method": "PUE",
                                "use": billing.cfdi.code,
                                "payment_form": typeCard,
                                "series":"a1",
                                "currency":"MXN"
                              }, {
                                  headers: {
                                  'Content-Type': 'application/json',
                                  "Access-Control-Allow-Origin": "*",
                                  'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
                                  }
                                }
                              ).then(function (response) {
                                console.log("sii", response)
        
                                   /*  if(response.data.error.code == "resource_missing"){
                                        setFieldError('number', "Error en el proceso")
                                        hideLoading()
                                    }else{ */

                                        let typeM ="membership_premium";
                                        axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/email/${typeM}`, {
                                            headers: {
                                            "Access-Control-Allow-Origin": "*",
                                            },
                                        }, {
                                            "name":name,
                                            "firstLastName":firstLastName,
                                            "secondLastName":secondLastName,
                                            "email":email
                                        }).then(res=>{
                                            console.log('res',res)
            
                                        })
                                        .catch(err=>{
                                            console.log('err',err)
        
                                    })
                                        
                                        
                                    axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/invoices/send_invoice_mail?idInvoice=${response.data.data.id}`, {
                                        headers: {
                                        'Content-Type': 'application/json',
                                        "Access-Control-Allow-Origin": "*",
                                        'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
                                        },
                                    },{"email": billing.invoiceEmail}).then(res=>{
                                        console.log('res',res)
        
                                        hideLoading();
                                        handleCheckout()
                                    return res
                                    })
                                    .catch(err=>{
                                        setFieldError('number', "Error en el proceso")
                                        hideLoading()
                                    return err 
                                })

                               
                                
                                

                               






                                
                              }).catch(function (response) {
                                console.log("nooo", response)
                                setFieldError('number', "Error en el proceso")
                                hideLoading()
                              }); 
                            }else{
                                axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/cancelSubscription?clientId=${response.data.id}`,  
                                {
                                    headers: {
                                    'Content-Type': 'application/json',
                                    "Access-Control-Allow-Origin": "*",
                                    'Authorization': `Bearer ${'TgC1n73rN37Gr0u9'}`
                                    }
                                  }
                                ).then(res => console.log("new", res))
                                  .catch(err => console.log("new err",err))

                                setFieldError('number', "Error en el proceso")
                                hideLoading()
                            }
                        }
                     }) 
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response)
                              if(error.response.data){
                                setFieldError('number', getCodeErrorMessage(error.response.data.error.code))
                              }

                            }
                       
                         hideLoading()
                       });   
              }) 
                    .catch(function (error) {
                        console.log('error sus', error)

                        if (error.response) {
                            console.log(error.response)
                              if(error.response.data){
                                setFieldError('number', getCodeErrorMessage(error.response.data.error.code))
                              }
                            }
                         hideLoading()
                    }); 
            }else if(response.data.error){
                let error;
                switch(response.data.error.code) {
                   
                  }
                setFieldError('number', error)
                hideLoading()
            }
           
          }) 
            .catch(function (error) {
                if (error.response) {
                  console.log(error.response)
                  console.log( error.response.data.error.code)
                 
                    if(error.response.data){
                    switch(error.response.data.error.code){
                        
                        case "card_not_supported":
                            error ='Tarjeta no compatible.'
                            setFieldError('number', error) 
                            break;
                        case "card_velocity_exceeded":
                            error ='card_velocity_exceeded'
                            setFieldError('number', error)  
                            break;
                        case "currency_not_supported":
                            error ='Moneda no compatible.'
                            setFieldError('number', error)  
                            break;
                        case "do_not_honor":
                            error ='Intenta mas adelante.'
                            setFieldError('number', error)  
                            break;
                        case "do_not_try_again":
                            error ='No intentes de nuevo.'
                            setFieldError('number', error)  
                            break;
                        case "duplicate_transaction":
                            error ='Transaccion duplicada.'
                            setFieldError('number', error)  
                            break;
                         case "expired_card":
                            error='La tarjeta está vencida.'
                            setFieldError('expiry', error)  
                            break;
                         case "fraudulent":
                            error='Tarjeta fraudulenta.'
                            setFieldError('number', error)  
                            break;
                         case "generic_decline":
                            error='generic_decline'
                            setFieldError('number', error) 
                             break;
                         case "incorrect_number":
                            error="El número de tarjeta es incorrecto."
                            setFieldError('number', error) 
                             break;
                         case "incorrect_cvc":
                            error='El código de seguridad de la tarjeta es incorrecto.'
                            setFieldError('cvc', error) 
                             break;
                         case "incorrect_pin":
                            error='pin incorrecto'
                            setFieldError('cvc', error) 
                             break;
                         case "insufficient_funds":
                            error='Fondos insuficientes.'
                            setFieldError('number', error) 
                             break;
                        
                         case "invalid_cvc":
                            error='El código de seguridad de la tarjeta no es válido.'
                            setFieldError('cvc', error) 
                             break;
                         case "invalid_expiry_year":
                            error='El año de vencimiento de la tarjeta no es válido.'
                            setFieldError('expiry', error) 
                             break;
                         case "invalid_number":
                            error='El número de tarjeta no es válido.'
                            setFieldError('number', error) 
                             break;
                         case "invalid_pin":
                            error='Pin invalido.'
                            setFieldError('number', error) 
                             break;
                         case "invalid_expiry_month":
                             error='El mes de vencimiento de la tarjeta no es válido.'
                             setFieldError('expiry', error) 
                             break;
                         case "lost_card":
                            error='Tarjeta perdida.'
                            setFieldError('number', error) 
                             break;
                        case "rate_limit":
                            error='Ocurrió un error debido a la cantidad de solicitudes.'
                            setFieldError('number', error)  
                            break;
                         case "merchant_blacklist":
                            error='merchant_blacklist'
                            setFieldError('number', error)  
                             break;
                         case "pin_try_exceeded":
                            error='pin_try_exceeded'
                            setFieldError('cvc', error) 
                             break;
                         case "processing_error":
                            error='Error al processar.'
                            setFieldError('number', error)  
                             break;
                         case "security_violation":
                            error='security_violation'
                            setFieldError('number', error)  
                             break;
                         case "service_not_allowed":
                            error='service_not_allowed'
                            setFieldError('number', error)
                             break;
                         case "stolen_card":
                            error='Tarjeta robada.'
                            setFieldError('number', error)
                             break;
                         case "stop_payment_order":
                            error='stop_payment_order'
                            setFieldError('number', error)
                             break;
                         case "testmode_decline":
                            error='testmode_decline'
                            setFieldError('number', error)
                             break;
                         case "transaction_not_allowed":
                            error='transaction_not_allowed'
                            setFieldError('number', error)
                             break;
                         case "try_again_later":
                            error='Intenta más tarde.'
                            setFieldError('number', error)
                             break;
                         case "withdrawal_count_limit_exceeded":
                            error='Límite de recuento excedido.'
                            setFieldError('number', error)
                             break;
                         case "card_declined":
                             error='La tarjeta fue rechazada.'
                             setFieldError('number', error)
                              break;
                        default: 
                        errorCard='error'
                            break;
                    } 
                   
                } else if (error.request) {
                       
                    setFieldError('number', "Error en el proceso")
                } else {
                  
                    setFieldError('number', "Error en el proceso")
                }
                   
                    hideLoading()
               
            }
        }); 

      
    }
    
    const handleInputFocus = (e) => {
        setFocusData(e.target.name)
      }

      const handleChangeMultiple = field => event => {
        event.preventDefault();
        let value = event.target.value;
        props.setFieldValue(field, value);
      };

    const handleRenderPaymentForm = (props) => {

        const { handleChange, handleSubmit, values, touched, errors, handleBlur, isValid } = props;

        return (
            <div className="contentMainBillingForm">
                <ContractModal  open={openContract} onClose={handleClose}/>
                <div className="contentTitle">
                    <p className="titleBillingPayment"> Método de pago </p>
                    <p>{devide  && devide}</p>
                </div>
                <Cards
                    cvc={values.cvc}
                    expiry={values.expiry}
                    focused={focus}
                    name={values.name}
                    placeholders={{name:"Nombre del Titular"}}
                    number={values.number}
                />
                <form className="contentFormCreditCard">
                <div style={{width: '100%'}}>
                <FormControl
                style={{maxWidth: '100%'}}
                    error={touched.typeCard && errors.typeCard ? true : false}
                    component="fieldset"
                    >
                   
                        <RadioGroup
                        row
                        aria-label="typeCard"
                        name="typeCard"
                        value={values.typeCard}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        >
                        <FormControlLabel
                            value="credito"
                            control={<Radio color="secondary" />}
                            label="Tarjetas de crédito"
                        />
                        <FormControlLabel
                            value="debito"
                            control={<Radio color="secondary"/>}
                            label="Tarjetas de débito"
                        />
                        </RadioGroup>
                  
                    {touched.typeCard && errors.typeCard ? (
                        <FormHelperText
                        color="error"
                        classes={{ root: classes.formHelperText }}
                        >
                        {errors.typeCard}
                        </FormHelperText>
                    ) : (
                        ''
                    )}
                    </FormControl>
                    </div>
                    <div className="containerInfoCard">
                    <TextField
                        label="Nombre titular de tarjeta"
                        name="name"
                        type="text"
                        variant="outlined"
                        onBlur={handleBlur}
                        value={values.name}
                        onChange={handleChange}
                        helperText={
                            touched.name && errors.name ? errors.name : ''
                        }
                        error={touched.name && errors.name ? true : false}
                        fullWidth
                        classes={{ root: classes.TextField }}
                        onFocus={handleInputFocus}
                    />
                    <TextField
                        label="Número de tarjeta"
                        name="number"
                        type="text"
                        variant="outlined"
                        value={values.number}
                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                        inputProps={{ maxLength: 16 }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        helperText={
                            touched.number && errors.number ? errors.number : ''
                        }
                        error={touched.number && errors.number ? true : false}
                        fullWidth
                        classes={{ root: classes.TextField }}
                        onFocus={handleInputFocus}
                    />
                    <div className="containerTwoInput">
                    
                    <TextField
                         name="expiry"
                         value={values.expiry}
                         variant="outlined"
                         onBlur={handleBlur}
                         onChange={handleChange}
                         onFocus={handleInputFocus}
                        id="expiry"
                        classes={{ root: classes.TextFieldS }}

                        InputProps={{
                        inputComponent: TextMaskCustom,
                        endAdornment: (
                            <InputAdornment position="end">
                                <Tooltip
                                    
                                    
                                    
                                    classes={{ tooltip: classes.customTooltip }}
                                    title={
                                        <p className={classes.tooltipParagraph}>
                                            Es la <b>fecha de expiración</b> que se encuentra grabada en la tarjeta, correspondiente al mes y año.
                                        </p>
                                    }
                                    placement='right'
                                >
                                    <HelpIcon />
                              
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                        helperText={
                            touched.expiry && errors.expiry ? errors.expiry : ''
                        }
                        error={touched.expiry && errors.expiry ? true : false}
                       
                    />
                      
                        
                      

                        <TextField
                            label="CVV"
                            name="cvc"
                            type="text"
                            variant="outlined"
                            value={values.cvc}
                            onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                            inputProps={{ maxLength: 4 }}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            helperText={
                                touched.cvc && errors.cvc ? errors.cvc : ''
                            }
                            error={touched.cvc && errors.cvc ? true : false}
                            
                            classes={{ root: classes.TextFieldS }}
                            onFocus={handleInputFocus}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                    <Tooltip
                                        
                                        
                                        
                                        classes={{ tooltip: classes.customTooltip }}
                                        title={
                                            <p className={classes.tooltipParagraph}>
                                            El <b>código de seguridad</b> es un número de 3 a 4 dígitos que figura al reverso de la tarjeta.
                                        </p>
                                        }
                                        placement='right'
                                    >
                                        <HelpIcon />
                                  
                                  </Tooltip>
                                </InputAdornment>
                                ),
                              }}
                        />

                    </div>
                    <div style={{width: '100%'}}>
                        <FormControlLabel
                        classes={{
                            root: classes.FormControlLabelRoot
                        }}
                        control={
                            <Checkbox
                                name="termsAndConditions"
                                id="termsAndConditions"
                                checked={values.termsAndConditions}
                                onChange={event => {
                                    handleChange(event);
                                    handleBlur(event);
                                }}
                                onBlur={handleBlur}
                                value="checked"
                                color="secondary"
                                label="Gilad Gray"
                                classes={{
                                    root: classes.checkPadding
                                }}
                            />
                        }
                        label={
                            <>
                            <p className={values.termsAndConditions ? classes.colorActiveCheck: classes.colorActiveLabel}>
                                <span className={classes.labelTermino}>Acepto los</span> <a className={classes.linkTerms} href="/informacion-adicional" target="_blank">términos y condiciones y el aviso de privacidad</a>
                            </p>
                            {touched.termsAndConditions && errors.termsAndConditions && (
                                <FormHelperText error>
                                    {errors.termsAndConditions}
                                    </FormHelperText>
                                )}
                                </>
                            }
                            />
                            </div>

                            <div style={{width: '100%'}}>
                        <FormControlLabel
                        classes={{
                            root: classes.FormControlLabelRoot
                        }}
                        control={
                            <Checkbox
                                name="contract"
                                id="terms"
                                checked={values.contract}
                                onChange={event => {
                                    handleChange(event);
                                    handleBlur(event);
                                }}
                                onBlur={handleBlur}
                                value="contract"
                                color="secondary"
                                label="Gilad Gray"
                                classes={{
                                    root: classes.checkPadding
                                }}
                            />
                        }
                        label={
                            <>
                            <p className={values.contract ? classes.colorActiveCheck: classes.colorActiveLabel}>
                                <span className={classes.labelTermino}>Acepto el</span> <a className={classes.linkTerms} href={'/files/Contrato-Adhesion.pdf'} target="_blank" rel="noopener noreferrer">contrato de servicios</a> de contacta abogado
                            </p>
                                {touched.contract && errors.contract && (
                                    <FormHelperText error>
                                        {errors.contract}
                                        </FormHelperText>
                                    )}
                                </>
                            }
                            />
                            </div>
                            </div>

                    <ButtonBase
                        type="submit"
                        onClick={handleSubmit}
                        className="buttonNext"
                        variant="primary"
                        disabled={!isValid}
                        buttonStyle={classes.button}
                    >
                        Finalizar pago
                    </ButtonBase>

                </form>

            </div>
        )
    }
    return (

        <Formik
            initialValues={formBillingValues}
            validationSchema={validationCard}
            onSubmit={handleSubmitBillingPaymentForm}
            render={handleRenderPaymentForm}
        />
    );
};

const mapDispatchToProps = dispatch => ({
    createBillingLaywers: (laywerUid, data) => dispatch(createBillingLaywers(laywerUid, data)),
    createStatusMembership: (laywerUid) => dispatch(createStatusMembership(laywerUid)),
    openModalPayments: ( open ) =>  dispatch( openModalPayments(open)),
      showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    createFingerprint: (laywerUid, data) =>  dispatch(createFingerprint(laywerUid, data)),
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    name: state.authClient.name,
    firstLastName: state.authClient.firstLastName,
    secondLastName: state.authClient.secondLastName,
    email: state.authClient.email,
    modalPayments: state.ModalReducer.openModalPayments,
    role: state.authClient.role,
    billing: state.billingReducer.billingData,
    membership: state.authClient.membership,
    typeMembership: state.authClient.membership.type,
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingPaymentForm);






/* 


{
    "invoice_id": "242095",    
    "total": 2322.03,
    "subtotal": 2001.75,
    "forma_pago": "04",
    "metodo_pago": "PUE",
    "lugar_expedicion": "76090",
    "moneda": "MXN",
    "tipo_de_cambio": 1,
    "receptor": {
        "nombre": "Alberto Montellano Sandoval",
        "rfc": "MOSA8311152G0",
        "email": "alberto.montellano@tcpip.tech",
        "uso_cfdi": "G03"
    },
    "conceptos": [
        {
            "clave": "78111500",
            "clave_unidad": "E54",
            "identificador": "6K9MVV CUAHUTEMOC BLANCO",
            "cantidad": 1,
            "unidad": "Viaje",
            "descripcion": "TRANSPORTACION AEREA DE QRO A MTY",
            "valor_unitario": 1744,
            "importe": 1744,
            "traslados": [
                {
                    "impuesto": "002",
                    "base": 1744,
                    "tipo_factor": "Tasa",
                    "tasa": 0.16,
                    "importe": 279.04
                }
            ]
        },
    ]

    }
 */

